export const ownerTypes = {
  individual: 'Individual',
  company: 'Company',
  fund: 'Private Equity Fund',
};
